export default __webpack_public_path__ + "static/media/facility_02_5.a9a95b46.png";